/**
 * Utilidades para debugging de errores en móvil
 * Uso: En la consola del navegador, ejecuta estas funciones
 */

// Función para ver todos los errores reportados
window.showErrorReports = () => {
    try {
        const reports = JSON.parse(localStorage.getItem('errorReports') || '[]');
        console.log('📊 Reportes de errores encontrados:', reports.length);

        if (reports.length === 0) {
            console.log('✅ No hay errores reportados');
            return;
        }

        reports.forEach((report, index) => {
            console.group(`🐛 Error ${index + 1} - ${new Date(report.timestamp).toLocaleString()}`);
            console.log('Mensaje:', report.message);
            console.log('URL:', report.url);
            console.log('Dispositivo:', report.platform);
            console.log('Pantalla:', report.screenSize);
            console.log('User Agent:', report.userAgent);
            console.log('Stack Trace:', report.stack);
            if (report.componentStack) {
                console.log('Component Stack:', report.componentStack);
            }
            console.groupEnd();
        });
    } catch (error) {
        console.error('Error al cargar reportes:', error);
    }
};

// Función para limpiar todos los errores
window.clearErrorReports = () => {
    if (window.confirm('¿Estás seguro de que quieres eliminar todos los reportes de errores?')) {
        localStorage.removeItem('errorReports');
        console.log('🗑️ Reportes de errores eliminados');
    }
};

// Función para exportar errores como JSON
window.exportErrorReports = () => {
    try {
        const reports = JSON.parse(localStorage.getItem('errorReports') || '[]');
        const dataStr = JSON.stringify(reports, null, 2);
        const dataBlob = new Blob([dataStr], { type: 'application/json' });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(dataBlob);
        link.download = `error-reports-${new Date().toISOString().split('T')[0]}.json`;
        link.click();

        console.log('📁 Reportes exportados como JSON');
    } catch (error) {
        console.error('Error al exportar reportes:', error);
    }
};

// Función para simular un error (para testing)
window.simulateError = () => {
    throw new Error('Error simulado para testing - ' + new Date().toISOString());
};

// Función para obtener información del dispositivo
window.getDeviceInfo = () => {
    const info = {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        language: navigator.language,
        screenSize: `${window.innerWidth}x${window.innerHeight}`,
        viewport: `${window.visualViewport?.width || 'N/A'}x${window.visualViewport?.height || 'N/A'}`,
        isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
        url: window.location.href,
        timestamp: new Date().toISOString()
    };

    console.log('📱 Información del dispositivo:', info);
    return info;
};

// Función para verificar si hay errores sin abrir el modal
window.checkForErrors = () => {
    try {
        const reports = JSON.parse(localStorage.getItem('errorReports') || '[]');
        const recentErrors = reports.filter(report => {
            const errorTime = new Date(report.timestamp);
            const oneHourAgo = new Date(Date.now() - 60 * 60 * 1000);
            return errorTime > oneHourAgo;
        });

        console.log(`🔍 Errores en la última hora: ${recentErrors.length}`);
        console.log(`📊 Total de errores: ${reports.length}`);

        if (recentErrors.length > 0) {
            console.log('⚠️ Errores recientes encontrados. Usa showErrorReports() para ver detalles.');
        }

        return { total: reports.length, recent: recentErrors.length };
    } catch (error) {
        console.error('Error al verificar errores:', error);
        return { total: 0, recent: 0 };
    }
};

// Función para mostrar ayuda
window.errorDebugHelp = () => {
    console.log(`
🔧 Utilidades de debugging de errores móviles:

📊 showErrorReports()     - Ver todos los errores reportados
🗑️ clearErrorReports()    - Eliminar todos los reportes
📁 exportErrorReports()   - Exportar errores como JSON
🐛 simulateError()        - Simular un error para testing
📱 getDeviceInfo()        - Obtener información del dispositivo
🔍 checkForErrors()       - Verificar si hay errores recientes
❓ errorDebugHelp()       - Mostrar esta ayuda

💡 Tip: En móvil, abre las herramientas de desarrollador y ejecuta estas funciones en la consola.
    `);
};

// Auto-ejecutar ayuda cuando se carga el script
console.log('🔧 Utilidades de debugging de errores móviles cargadas. Ejecuta errorDebugHelp() para ver las funciones disponibles.'); 